<template>
  <button class="p-0 w-full" type="button" @click="showSearchUi">
    <label class="sr-only" for="#site-search">Site search</label>
    <div class="flex">
      <input
        id="#site-search"
        class="font-inherit leading-lose p-2 lg:px-6 lg:text-2xl rounded-l-sm w-full"
        type="search"
        name="#site-search"
        placeholder="Search by year, stage, artist…"
      />
      <span class="btn btn-lg btn-search flex items-center rounded-l-none"
        >Search
        <svg class="w-2 transform ml-3" viewBox="0 0 24 24">
          <use xlink:href="#icon-triangle" />
        </svg>
      </span>
    </div>
  </button>
  <teleport to="#search-container">
    <modal v-show="searchShown" :is-shown="searchShown" @hide="hideSearchUi">
      <search @search="showSearchUi" />
    </modal>
  </teleport>
</template>
<script>
import Search from "./Search";
import Modal from "./vue-components/Modal";

export default {
  components: {
    Search,
    Modal,
  },
  data() {
    return {
      searchShown: false,
    };
  },
  methods: {
    showSearchUi() {
      this.searchShown = true;
    },
    hideSearchUi() {
      this.searchShown = false;
    },
  },
};
</script>
